module.exports = __webpack_public_path__ + "nc_static/media/bar-chart.svg.6ac1cf9a.icon";